import { Badge, type BadgeProps } from '../../primitives/badge';
import { CardDescription, CardHeader, CardTitle } from '../../primitives/card';

import type { JSX } from 'react';

export type CardHeaderBadge =
  | string
  | {
      label: string;
      variant: NonNullable<BadgeProps['variant']>;
    };

export interface CardHeaderSimpleProps {
  action?: JSX.Element;
  badges?: CardHeaderBadge[];
  description?: string | JSX.Element;
  icon?: JSX.Element;
  title?: string | JSX.Element;
}

export function CardHeaderSimple({
  action,
  badges,
  description,
  icon,
  title,
}: CardHeaderSimpleProps) {
  return (
    <CardHeader className="grid gap-2 space-y-0">
      <div className="flex flex-row items-center justify-between gap-6 space-y-0">
        <div className="space-y-2">
          <CardTitle className="flex items-center">
            {icon ? <div className="mr-2 text-primary">{icon}</div> : null}
            {typeof title === 'string' ? (
              <span>{`${title.charAt(0).toUpperCase()}${title.slice(1)}`}</span>
            ) : (
              title
            )}
          </CardTitle>
          {description ? (
            <CardDescription className="line-clamp-3">{description}</CardDescription>
          ) : null}
        </div>
        {action}
      </div>
      {badges && badges.length > 0 ? (
        <div className="flex gap-2">
          {badges.map((badge, index) => (
            <Badge
              className="font-medium"
              key={`${typeof badge === 'string' ? badge : badge.label}-${index}`}
              variant={typeof badge === 'string' ? 'secondary' : badge.variant}
            >
              {typeof badge === 'string' ? badge : badge.label}
            </Badge>
          ))}
        </div>
      ) : null}
    </CardHeader>
  );
}
